module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/about-shannon-787.81e7d399dedd6b8a.jpg"+" 787w",
        images: [{path: "https://static.sniffspot.com/packs/img/about-shannon-787.81e7d399dedd6b8a.jpg",width: 787,height: 960}],
        src: "https://static.sniffspot.com/packs/img/about-shannon-787.81e7d399dedd6b8a.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/about-shannon-787.81e7d399dedd6b8a.jpg"},
        
        width: 787,
        height: 960
      }